import React from 'react';
import { IconArrowUpRight } from '@tabler/icons-react';

/*
    The external-link arrow for TEXT links ("Invoice 1042 ↗", "Open Shopify ↗"). Put it
    inside the link text, right after the words, and wrap the two in a span:

        <Anchor label={<span>Invoice 1042<InlineLinkIcon /></span>} ... />

    The span matters: Grommet's Anchor is inline-flex, so without it the arrow becomes a
    flex item aligned to the top of the line instead of the text baseline.

    It is drawn inline on the text's baseline and sized from the text (0.5em), so it reads
    as part of the link at any font size, rather than a separately centred icon. The
    viewBox is cropped tight around the arrow so its bottom lands on the baseline. Colour
    follows the link (currentColor).

    Buttons and menu items with an arrow keep using FontAwesomeIcon.
*/
const InlineLinkIcon = () => (
    <IconArrowUpRight
        aria-hidden="true"
        stroke={1.75}
        viewBox="6 6 12 12"
        // Size as an inline style rather than the width/height attributes, which any
        // stylesheet width rule would override
        style={{
            width: '0.5em',
            height: '0.5em',
            display: 'inline-block',
            verticalAlign: 'baseline',
            marginLeft: '0.25em',
            overflow: 'visible',
        }}
    />
);

export default InlineLinkIcon;
